import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('ContentWrapper')(() => css({
    position: 'relative',
    maxHeight: 'calc(100dvh - 100px)',
    overflowY: 'scroll',
    overflowX: 'hidden',
    mr: '-30px',
    pr: '30px',
    pb: '5px',
}));
themeStyles.addBaseStyles('BtnWrapper')(css({
    display: ['none', 'none', 'block'],
    position: 'sticky',
    width: '100%',
    textAlign: 'right',
    right: '34px',
    bottom: '2px',
    '&>button': {
        marginRight: '-48px',
    },
}));
themeStyles.addBaseStyles('SectionWrapper')(css({
    display: 'flex',
    gap: 'default',
    flexDirection: 'row',
    justifyContent: 'space-between',
    mt: 'xs',
    '&>div': {
        width: '100%',
    },
}));
themeStyles.addBaseStyles('SectionRadioContent')(({ selected }) => css({
    border: '1px solid',
    borderColor: selected ? 'blues.1' : 'grey.3',
    borderRadius: '3px',
    padding: 'm',
}));
themeStyles.addBaseStyles('SectionRadio')(css({
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 'm',
}));
themeStyles.addBaseStyles('ModelWrapper')(css({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    p: 'm',
    backgroundColor: 'grey.5',
}));
themeStyles.addBaseStyles('ModelImage')(css({
    maxWidth: '300px',
    maxHeight: '140px',
    margin: '0',
}));
themeStyles.addBaseStyles('ModelBadge')(css({
    height: '16px',
    width: '144px',
    mb: 's',
    objectFit: 'contain',
    marginX: '0',
    objectPosition: 'left',
}));
export default themeStyles;
